import Petrol from "containers/petrol";
import React, { useEffect, useState } from "react";
import { sendNotification } from "../../services/backend";
import {
  addNotification,
  deleteClient,
  editClient,
  getClient,
} from "../../services/firebase";
export default function Home() {
  const [plate, setPlate] = useState("");
  const [client, setClient] = useState();
  const [notification, setNotification] = useState("");
  const search = () => {
    getClient(plate.toUpperCase()).then((resp) => {
      setClient(resp);
    });
  };
  const changeDate = (key) => (e) => {
    client[key] = e.target.value;
    setClient({ ...client });
  };
  const sendUserNotification = () => {
    sendNotification(notification, client.fcm);
  };
  const sendAllNotification = () => {
    sendNotification(notification, "/topics/all").then((resp) => {
      addNotification(notification);
    });
  };
  const handleEditClient = () => {
    editClient(client);
  };
  const handleDeleteClient = () => {
    deleteClient(client);
  };
  useEffect(() => {
    setTimeout(() => {
      for (var index = 0; index < 3; index++) {
        console.log("first", index);
      }
    }, 1);
    setTimeout(() => {
      for (let index = 0; index < 3; index++) {
        console.log("seconf", index);
      }
    }, 1);
  }, []);
  return (
    <div>
      <div style={{ marginTop: "2%" }}>
        plate
        <input
          placeholder="plate"
          value={plate}
          onChange={(e) => setPlate(e.target.value)}
        />
        <input type="button" onClick={search} value="search" />
        {client && (
          <div>
            <span>
              <input
                type="button"
                value={"delete"}
                onClick={handleDeleteClient}
              />
            </span>
            <span>
              <input
                type="button"
                value={"send notification"}
                onClick={sendUserNotification}
              />
            </span>
            <span>
              <input type="button" value={"edit"} onClick={handleEditClient} />
            </span>

            {Object.keys(client).map((key, index) => {
              if (key === "fcm") {
                return null;
              }
              return (
                <div key={index}>
                  <span style={{ marginRight: "1%" }}>{key}</span>
                  <input value={client[key]} onChange={changeDate(key)} />
                </div>
              );
            })}
            <input
              placeholder="notification"
              value={notification}
              onChange={(e) => setNotification(e.target.value)}
            />
            <input
              type="button"
              value={"send to all"}
              onClick={sendAllNotification}
            />
          </div>
        )}
      </div>
      <Petrol />
    </div>
  );
}
